export const actionTypes = {
  GET_SURVEY_INFO: "GET_SURVEY_INFO",
  SET_SURVEY_INFO: "SET_SURVEY_INFO",
  GET_FILTERED_SURVEY: "GET_FILTERED_SURVEY",
  GET_SURVEY_POS_BY_ID: "GET_SURVEY_POS_BY_ID",
  SET_SURVEY_POS_BY_ID: "SET_SURVEY_POS_BY_ID",
  SUBMIT_POS_SURVEY: "SUBMIT_POS_SURVEY",
};

export const actions = {
  getSurveyInfo: (payload) => ({
    type: actionTypes.GET_SURVEY_INFO,
    payload: payload,
  }),

  setSurveyInfo: (payload) => ({
    type: actionTypes.SET_SURVEY_INFO,
    payload: payload,
  }),

  getFilteredSurvey: (payload) => ({
    type: actionTypes.GET_FILTERED_SURVEY,
    payload: payload,
  }),

  getSurveyInfoById: (payload) => ({
    type: actionTypes.GET_SURVEY_POS_BY_ID,
    payload: payload,
  }),

  setSurveyInfoById: (payload) => ({
    type: actionTypes.SET_SURVEY_POS_BY_ID,
    payload: payload,
  }),

  submitPosSurvey: (payload) => ({
    type: actionTypes.SUBMIT_POS_SURVEY,
    payload: payload,
  }),
};
